import { ElementRef, Injectable, QueryList } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class SectionsService {
	sections: QueryList<any>;
}
